var cilClipboard = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M432,56H376V88h48V464H88V88h48V56H80A24.028,24.028,0,0,0,56,80V472a24.028,24.028,0,0,0,24,24H432a24.028,24.028,0,0,0,24-24V80A24.028,24.028,0,0,0,432,56Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M192,140H320a24.028,24.028,0,0,0,24-24V16H168V116A24.028,24.028,0,0,0,192,140Zm8-92H312v60H200Z' class='ci-primary'/>"];

export { cilClipboard };

